export enum QUERY_NAME {
  userActivity = 'userActivity',
  currentUser = 'currentUser',
}
